import { createApp, defineAsyncComponent, type Component } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
// import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import PickList from 'primevue/picklist'
import VirtualScroller from 'primevue/virtualscroller'
import Sidebar from 'primevue/sidebar'
import { i18n } from './i18n'
import App from './App.vue'
import Aura from '@primevue/themes/aura'
import router from './router'
import axios from './plugins/axios'
import './plugins/vee-validate' // Import vee-validate rules

// Import all MOP components
// Button components
import MOPButton from './components/primevuecomponents/button/MOPButton/MOPButton.vue'
import MOPSplitButton from './components/primevuecomponents/button/MOPSplitButton/MOPSplitButton.vue'

// Data components
import MOPCarousel from './components/primevuecomponents/data/MOPCarousel/MOPCarousel.vue'
import MOPDataTable from './components/primevuecomponents/data/MOPDataTable/MOPDataTable.vue'
import MOPDataView from './components/primevuecomponents/data/MOPDataView/MOPDataView.vue'
import MOPOrderList from './components/primevuecomponents/data/MOPOrderList/MOPOrderList.vue'
import MOPOrganizationChart from './components/primevuecomponents/data/MOPOrganizationChart/MOPOrganizationChart.vue'
import MOPPaginator from './components/primevuecomponents/data/MOPPaginator/MOPPaginator.vue'
import MOPPickList from './components/primevuecomponents/data/MOPPickList/MOPPickList.vue'
import MOPTimeline from './components/primevuecomponents/data/MOPTimeline/MOPTimeline.vue'
import MOPTree from './components/primevuecomponents/data/MOPTree/MOPTree.vue'
import MOPTreeTable from './components/primevuecomponents/data/MOPTreeTable/MOPTreeTable.vue'
import MOPVirtualScroller from './components/primevuecomponents/data/MOPVirtualScroller/MOPVirtualScroller.vue'
import MOPTableSkeleton from './components/MOPLoader/MOPTableSkeleton.vue'

// Form components
import MOPAutocomplete from './components/primevuecomponents/form/MOPAutocomplete/MOPAutocomplete.vue'
import MOPCascadeSelect from './components/primevuecomponents/form/MOPCascadeSelect/MOPCascadeSelect.vue'
import MOPCheckbox from './components/primevuecomponents/form/MOPCheckbox/MOPCheckbox.vue'
import MOPColorPicker from './components/primevuecomponents/form/MOPColorPicker/MOPColorPicker.vue'
import MOPDatepicker from './components/primevuecomponents/form/MOPDatepicker/MOPDatepicker.vue'
import MOPDropdown from './components/primevuecomponents/form/MOPDropdown/MOPDropdown.vue'
import MOPEditor from './components/primevuecomponents/form/MOPEditor/MOPEditor.vue'
import MOPFileUpload from './components/primevuecomponents/form/MOPFileUpload/MOPFileUpload.vue'
import MOPInputGroup from './components/primevuecomponents/form/MOPInputGroup/MOPInputGroup.vue'
import MOPInputIcon from './components/primevuecomponents/form/MOPInputIcon/MOPInputIcon.vue'
import MOPInputMask from './components/primevuecomponents/form/MOPInputMask/MOPInputMask.vue'
import MOPInputNumber from './components/primevuecomponents/form/MOPInputNumber/MOPInputNumber.vue'
import MOPInputOTP from './components/primevuecomponents/form/MOPInputOTP/MOPInputOTP.vue'
import MOPInputSwitch from './components/primevuecomponents/form/MOPInputSwitch/MOPInputSwitch.vue'
import MOPInputText from './components/primevuecomponents/form/MOPInputText/MOPInputText.vue'
import MOPKnob from './components/primevuecomponents/form/MOPKnob/MOPKnob.vue'
import MOPListbox from './components/primevuecomponents/form/MOPListbox/MOPListbox.vue'
import MOPMultiSelect from './components/primevuecomponents/form/MOPMultiSelect/MOPMultiSelect.vue'
import MOPPassword from './components/primevuecomponents/form/MOPPassword/MOPPassword.vue'
import MOPRadioButton from './components/primevuecomponents/form/MOPRadioButton/MOPRadioButton.vue'
import MOPRating from './components/primevuecomponents/form/MOPRating/MOPRating.vue'
import MOPSelectButton from './components/primevuecomponents/form/MOPSelectButton/MOPSelectButton.vue'
import MOPSlider from './components/primevuecomponents/form/MOPSlider/MOPSlider.vue'
import MOPSpinButton from './components/primevuecomponents/form/MOPSpinButton/MOPSpinButton.vue'
import MOPTextarea from './components/primevuecomponents/form/MOPTextarea/MOPTextarea.vue'
import MOPToggleButton from './components/primevuecomponents/form/MOPToggleButton/MOPToggleButton.vue'
import MOPTreeSelect from './components/primevuecomponents/form/MOPTreeSelect/MOPTreeSelect.vue'
import MOPTriStateCheckbox from './components/primevuecomponents/form/MOPTriStateCheckbox/MOPTriStateCheckbox.vue'

// Media components
import MOPGalleria from './components/primevuecomponents/media/MOPGalleria/MOPGalleria.vue'
import MOPImage from './components/primevuecomponents/media/MOPImage/MOPImage.vue'

// Menu components
import MOPBreadcrumb from './components/primevuecomponents/menu/MOPBreadcrumb/MOPBreadcrumb.vue'
import MOPContextMenu from './components/primevuecomponents/menu/MOPContextMenu/MOPContextMenu.vue'
import MOPDock from './components/primevuecomponents/menu/MOPDock/MOPDock.vue'
import MOPMegaMenu from './components/primevuecomponents/menu/MOPMegaMenu/MOPMegaMenu.vue'
import MOPMenu from './components/primevuecomponents/menu/MOPMenu/MOPMenu.vue'
import MOPMenuBar from './components/primevuecomponents/menu/MOPMenuBar/MOPMenuBar.vue'
import MOPPanelMenu from './components/primevuecomponents/menu/MOPPanelMenu/MOPPanelMenu.vue'
import MOPTabMenu from './components/primevuecomponents/menu/MOPTabMenu/MOPTabMenu.vue'
import MOPTieredMenu from './components/primevuecomponents/menu/MOPTieredMenu/MOPTieredMenu.vue'

// Messages components
import MOPInlineMessage from './components/primevuecomponents/messages/MOPInlineMessage/MOPInlineMessage.vue'
import MOPToast from './components/primevuecomponents/messages/MOPToast/MOPToast.vue'

// Misc components
import MOPAvatar from './components/primevuecomponents/misc/MOPAvatar/MOPAvatar.vue'
import MOPAvatarGroup from './components/primevuecomponents/misc/MOPAvatar/MOPAvatarGroup.vue'
import MOPBadge from './components/primevuecomponents/misc/MOPBadge/MOPBadge.vue'
import MOPOverlayBadge from './components/primevuecomponents/misc/MOPBadge/MOPOverlayBadge.vue'
import MOPMeterGroup from './components/primevuecomponents/misc/MOPMeterGroup/MOPMeterGroup.vue'
import MOPProgressBar from './components/primevuecomponents/misc/MOPProgressBar/MOPProgressBar.vue'
import MOPProgressSpinner from './components/primevuecomponents/misc/MOPProgressSpinner/MOPProgressSpinner.vue'
import MOPBlockUI from './components/primevuecomponents/misc/MOPBlockUI/MOPBlockUI.vue'
import MOPChip from './components/primevuecomponents/misc/MOPChip/MOPChip.vue'
import MOPInplace from './components/primevuecomponents/misc/MOPInplace/MOPInplace.vue'
import MOPRipple from './components/primevuecomponents/misc/MOPRipple/MOPRipple.vue'
import MOPScrollTop from './components/primevuecomponents/misc/MOPScrollTop/MOPScrollTop.vue'
import MOPSkeleton from './components/primevuecomponents/misc/MOPSkeleton/MOPSkeleton.vue'
import MOPTag from './components/primevuecomponents/misc/MOPTag/MOPTag.vue'
import MOPTerminal from './components/primevuecomponents/misc/MOPTerminal/MOPTerminal.vue'
import MOPTableEmpty from './components/Empty state/MOPTableEmpty.vue'

// Overlay components
import MOPConfirmPopup from './components/primevuecomponents/overlay/MOPConfirmPopup/MOPConfirmPopup.vue'
import MOPDialog from './components/primevuecomponents/overlay/MOPDialog/MOPDialog.vue'
import MOPDrawer from './components/primevuecomponents/overlay/MOPDrawer/MOPDrawer.vue'
import MOPPopover from './components/primevuecomponents/overlay/MOPPopover/MOPPopover.vue'
import MOPTooltip from './components/primevuecomponents/overlay/MOPTooltip/MOPTooltip.vue'

// Panel components
import MOPAccordion from './components/primevuecomponents/panel/MOPAccordion/MOPAccordion.vue'
import MOPAccordionTab from './components/primevuecomponents/panel/MOPAccordion/MOPAccordionTab.vue'
import MOPCard from './components/primevuecomponents/panel/MOPCard/MOPCard.vue'
import MOPDivider from './components/primevuecomponents/panel/MOPDivider/MOPDivider.vue'
import MOPFieldset from './components/primevuecomponents/panel/MOPFieldset/MOPFieldset.vue'
import MOPPanel from './components/primevuecomponents/panel/MOPPanel/MOPPanel.vue'
import MOPScrollPanel from './components/primevuecomponents/panel/MOPScrollPanel/MOPScrollPanel.vue'
import MOPSplitter from './components/primevuecomponents/panel/MOPSplitter/MOPSplitter.vue'
import MOPSplitterPanel from './components/primevuecomponents/panel/MOPSplitter/MOPSplitterPanel.vue'
import MOPStepper from './components/primevuecomponents/panel/MOPStepper/MOPStepper.vue'
import MOPTabView from './components/primevuecomponents/panel/MOPTabView/MOPTabView.vue'
import MOPTabPanel from './components/primevuecomponents/panel/MOPTabView/MOPTabPanel.vue'
import MOPToolbar from './components/primevuecomponents/panel/MOPToolbar/MOPToolbar.vue'
import MOPSuccessDialog from './components/primevuecomponents/MOPSuccess/MOPSuccessDialog.vue'
import './assets/main.scss'
import 'primeicons/primeicons.css'
import 'tailwindcss-primeui'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import AccountExportFile from "./modules/accounts/exportfile"
// Create app instance
const app = createApp(App)

// Register Account components with proper async loading
Object.entries(AccountExportFile).forEach(([name, componentLoader]) => {
  app.component(name, defineAsyncComponent(() => componentLoader as any));
});

// Add plugins
app.use(createPinia())
app.use(PrimeVue, {
  theme: {
    preset: Aura
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.use(i18n)
app.use(router)

// Make axios instance available globally
app.config.globalProperties.$axios = axios

// Register directives
app.directive('tooltip', Tooltip)
app.directive('ripple', MOPRipple)

// Register base PrimeVue components
app.component('PickList', PickList)
app.component('VirtualScroller', VirtualScroller)
app.component('Sidebar', Sidebar)

// Register MOP components
// Button components
app.component('MOPButton', MOPButton)
app.component('MOPSplitButton', MOPSplitButton)

// Data components
app.component('MOPCarousel', MOPCarousel)
app.component('MOPDataTable', MOPDataTable)
app.component('MOPDataView', MOPDataView)
app.component('MOPOrderList', MOPOrderList)
app.component('MOPOrganizationChart', MOPOrganizationChart)
app.component('MOPPaginator', MOPPaginator)
app.component('MOPPickList', MOPPickList)
app.component('MOPTimeline', MOPTimeline)
app.component('MOPTree', MOPTree)
app.component('MOPTreeTable', MOPTreeTable)
app.component('MOPVirtualScroller', MOPVirtualScroller)
app.component('MOPTableEmpty', MOPTableEmpty)
app.component('MOPTableSkeleton', MOPTableSkeleton)

// Form components
app.component('MOPAutocomplete', MOPAutocomplete)
app.component('MOPCascadeSelect', MOPCascadeSelect)
app.component('MOPCheckbox', MOPCheckbox)
app.component('MOPColorPicker', MOPColorPicker)
app.component('MOPDatepicker', MOPDatepicker)
app.component('MOPDropdown', MOPDropdown)
app.component('MOPEditor', MOPEditor)
app.component('MOPFileUpload', MOPFileUpload)
app.component('MOPInputGroup', MOPInputGroup)
app.component('MOPInputIcon', MOPInputIcon)
app.component('MOPInputMask', MOPInputMask)
app.component('MOPInputNumber', MOPInputNumber)
app.component('MOPInputOTP', MOPInputOTP)
app.component('MOPInputSwitch', MOPInputSwitch)
app.component('MOPInputText', MOPInputText)
app.component('MOPKnob', MOPKnob)
app.component('MOPListbox', MOPListbox)
app.component('MOPMultiSelect', MOPMultiSelect)
app.component('MOPPassword', MOPPassword)
app.component('MOPRadioButton', MOPRadioButton)
app.component('MOPRating', MOPRating)
app.component('MOPSelectButton', MOPSelectButton)
app.component('MOPSlider', MOPSlider)
app.component('MOPSpinButton', MOPSpinButton)
app.component('MOPTextarea', MOPTextarea)
app.component('MOPToggleButton', MOPToggleButton)
app.component('MOPTreeSelect', MOPTreeSelect)
app.component('MOPTriStateCheckbox', MOPTriStateCheckbox)

// Media components
app.component('MOPGalleria', MOPGalleria)
app.component('MOPImage', MOPImage)

// Menu components
app.component('MOPBreadcrumb', MOPBreadcrumb)
app.component('MOPContextMenu', MOPContextMenu)
app.component('MOPDock', MOPDock)
app.component('MOPMegaMenu', MOPMegaMenu)
app.component('MOPMenu', MOPMenu)
app.component('MOPMenuBar', MOPMenuBar)
app.component('MOPPanelMenu', MOPPanelMenu)
app.component('MOPTabMenu', MOPTabMenu)
app.component('MOPTieredMenu', MOPTieredMenu)

// Messages components
app.component('MOPInlineMessage', MOPInlineMessage)
app.component('MOPToast', MOPToast)

// Misc components
app.component('MOPAvatar', MOPAvatar)
app.component('MOPAvatarGroup', MOPAvatarGroup)
app.component('MOPBadge', MOPBadge)
app.component('MOPOverlayBadge', MOPOverlayBadge)
app.component('MOPMeterGroup', MOPMeterGroup)
app.component('MOPProgressBar', MOPProgressBar)
app.component('MOPProgressSpinner', MOPProgressSpinner)
app.component('MOPBlockUI', MOPBlockUI)
app.component('MOPChip', MOPChip)
app.component('MOPInplace', MOPInplace)
app.component('MOPScrollTop', MOPScrollTop)
app.component('MOPSkeleton', MOPSkeleton)
app.component('MOPTag', MOPTag)
app.component('MOPTerminal', MOPTerminal)

// Overlay components
app.component('MOPConfirmPopup', MOPConfirmPopup)
app.component('MOPDialog', MOPDialog)
app.component('MOPDrawer', MOPDrawer)
app.component('MOPPopover', MOPPopover)
app.component('MOPTooltip', MOPTooltip)

// Panel components
app.component('MOPAccordion', MOPAccordion)
app.component('MOPAccordionTab', MOPAccordionTab)
app.component('MOPCard', MOPCard)
app.component('MOPDivider', MOPDivider)
app.component('MOPFieldset', MOPFieldset)
app.component('MOPPanel', MOPPanel)
app.component('MOPScrollPanel', MOPScrollPanel)
app.component('MOPSplitter', MOPSplitter)
app.component('MOPSplitterPanel', MOPSplitterPanel)
app.component('MOPStepper', MOPStepper)

app.component('MOPTabView', TabView)
app.component('MOPTabPanel', TabPanel)
app.component('MOPToolbar', MOPToolbar)
app.component('MOPSuccessDialog', MOPSuccessDialog)

// Global event listener to prevent Enter key from triggering submit buttons
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    const target = event.target as HTMLElement

    // Check if the target is an input, textarea, or other form element
    if (target && (
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.tagName === 'SELECT' ||
      target.contentEditable === 'true'
    )) {
      // Check if it's not a submit button or button input
      if (target.tagName === 'INPUT') {
        const inputElement = target as HTMLInputElement
        if (inputElement.type === 'submit' || inputElement.type === 'button') {
          return // Allow submit buttons to work normally
        }
      }

      // Prevent the default form submission behavior
      const form = target.closest('form')
      if (form) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }
})

// Mount the app
app.mount('#app')
